/* eslint-disable no-nested-ternary */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import 'moment-timezone'
import moment from 'moment'
import { Form, Button, Modal, Container, Row, Col } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons'
import apiServices from '../services/apiServices'

function Warn({ setting }) {
  const { size = 'md', show = false, handleClose } = setting

  return (
    <Modal
      style={{ zIndex: 1501 }}
      size={size}
      show={!!show}
      onHide={() => handleClose(false)}
    >
      <Modal.Header
        className="AccFormModal justify-content-center text-center pt-4"
        closeButton
      >
        <Modal.Title>
          <h4>系統訊息</h4>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex AccformCard">
        <div className="assPermis w-100">
          <Form className="px-2 Form-card flex-grow-1">
            <Form.Group className="px-5 lh-md text-center text-wom">
              <FontAwesomeIcon
                icon={faCircleExclamation}
                style={{ height: '5rem' }}
                className="my-4"
              />
              <Form.Label className="w-100 fs-5 fw-bold text-center pb-4">
                確定要刪除嗎？
              </Form.Label>
            </Form.Group>
          </Form>
        </div>
      </Modal.Body>
      <Modal.Footer className="sendForm justify-content-center py-3">
        <Button variant="secondary" onClick={() => setting.handleClose(false)}>
          取消
        </Button>
        <Button variant="wom" onClick={() => setting.handleClose(true)}>
          確定
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default function Billing() {
  // 選擇月份
  const [month, setMonth] = useState('')
  // 載入後數據
  const [billing, setBilling] = useState({
    sheet: {},
    insights: {},
    ca: {},
    projects: [],
  })
  const [combine, setCombine] = useState('refined')
  // 顯示資料
  const { insights, ca } = billing
  // filter 狀態
  const [providerFilter, setProviderFilter] = useState('all')
  const [hasCAFilter, setHasCAFilter] = useState('all')
  // 載入提示
  const [loading, setLoading] = useState(false)

  // 載入資料函式
  const loadBilling = async () => {
    if (!month) return
    setLoading(true)
    const start = moment(`${month}-01`).format('YYYY-MM-DD')
    const end = moment(start).endOf('month').format('YYYY-MM-DD')
    const [insightsRes, caRes] = await Promise.all([
      // apiServices.data({ path: 'billing/sheet', method: 'get' }),
      apiServices.data({
        path: 'billing/insights',
        method: 'get',
        params: { since: start, until: end },
      }),
      apiServices.data({ path: 'billing/ca', method: 'get' }),
      // apiServices.data({ path: 'billing/project', method: 'get' }),
    ])
    setBilling({
      // sheet: sheetRes,
      insights: insightsRes.refined,
      ca: caRes,
      // projects: projRes.projects || [],
    })
    setLoading(false)
  }

  // 過濾後的列
  const rows = Object.values(insights).filter((r) => {
    if (providerFilter !== 'all' && r.provider !== providerFilter) return false
    const targetCA = ca[r.account_id] || ca[r.account_name.toLowerCase()]
    if (hasCAFilter === 'with' && !targetCA) return false
    if (hasCAFilter === 'without' && targetCA) return false
    return true
  })

  // 計算總計
  const totalSpend = rows.reduce((sum, r) => sum + r.spend, 0)
  const totalProfit = rows.reduce((sum, r) => {
    const targetCA = ca[r.account_id] || ca[r.account_name.toLowerCase()]
    const profit = targetCA ? (1 + targetCA.AC * 0.01) * r.spend : r.spend
    return sum + profit
  }, 0)

  // 匯出 CSV
  const exportCSV = () => {
    const header = [
      '帳戶ID',
      '帳戶名稱',
      ...(combine === 'refined' ? ['活動名稱'] : []),
      '花費',
      '客戶名稱',
      'AC',
      '粗估收益',
      '媒體',
    ]
    const csvRows = [header.join(',')]
    rows.forEach((r) => {
      const targetCA = ca[r.account_id] || ca[r.account_name.toLowerCase()]
      const profit = targetCA
        ? ((1 + targetCA.AC * 0.01) * r.spend).toFixed(2)
        : (r.spend || 0).toFixed(2)
      const cols = [
        r.account_id,
        r.account_name,
        ...(combine === 'refined' ? [r.campaign_name] : []),
        (r.spend || 0).toFixed(2),
        targetCA ? targetCA['客戶名稱'] : 'unknown',
        targetCA && targetCA.AC !== undefined ? `${targetCA.AC}%` : 'unknown',
        profit,
        r.provider,
      ]
      csvRows.push(cols.map((v) => `"${v}"`).join(','))
    })
    const blob = new Blob([`\uFEFF${csvRows.join('\n')}`], {
      type: 'text/csv;charset=utf-8;',
    })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = `billing_${month}.csv`
    a.click()
    URL.revokeObjectURL(url)
  }

  // 欄位
  const fields =
    combine === 'refined'
      ? [
          { label: '帳戶ID', key: 'account_id' },
          { label: '帳戶名稱', key: 'account_name' },
          { label: '活動名稱', key: 'campaign_name' },
        ]
      : [
          { label: '帳戶ID', key: 'account_id' },
          { label: '帳戶名稱', key: 'account_name' },
        ]

  return (
    <Container className="p-3">
      <Row className="mb-3 align-items-center">
        <Col xs={3}>
          <Form.Control
            type="month"
            value={month}
            onChange={(e) => setMonth(e.target.value)}
          />
        </Col>
        <Col xs={2}>
          <Button onClick={loadBilling} disabled={!month || loading}>
            {loading ? '載入中...' : '載入資料'}
          </Button>
        </Col>
        <Col className="text-end">
          <Button variant="success" onClick={exportCSV} disabled={!rows.length}>
            匯出 CSV
          </Button>
        </Col>
      </Row>
      <Row className="mb-2">
        <Col xs={4}>
          <Form.Select
            value={combine}
            onChange={(e) => setCombine(e.target.value)}
          >
            <option value="refined">不合併</option>
            <option value="customer_combined">合併同一客戶</option>
            <option value="account_combined">合併同一帳戶</option>
          </Form.Select>
        </Col>
        <Col xs={3}>
          <Form.Select
            value={providerFilter}
            onChange={(e) => setProviderFilter(e.target.value)}
          >
            <option value="all">所有媒體</option>
            <option value="facebook">Facebook</option>
            <option value="google">Google</option>
            <option value="linkedin">LinkedIn</option>
            <option value="twitter">Twitter</option>
            <option value="criteo">Criteo</option>
          </Form.Select>
        </Col>
        <Col xs={3}>
          <Form.Select
            value={hasCAFilter}
            onChange={(e) => setHasCAFilter(e.target.value)}
          >
            <option value="all">所有</option>
            <option value="with">有客戶名稱</option>
            <option value="without">無客戶名稱</option>
          </Form.Select>
        </Col>
      </Row>
      {/* 表格標頭 */}
      <Row className="fw-bold border-top border-bottom flex-nowrap">
        {fields.map((f) => (
          <Col xs={2} key={f.key}>
            {f.label}
          </Col>
        ))}
        <Col xs={2}>花費</Col>
        <Col xs={2}>客戶名稱</Col>
        <Col xs={2}>AC</Col>
        <Col xs={2}>粗估收益</Col>
        {/* <Col xs={2}>媒體</Col> */}
      </Row>
      {/* 總計列 */}
      <Row className="fw-bold border-bottom flex-nowrap">
        {fields.map((f, i) => (
          <Col xs={2} key={f.key}>
            {i === 0 ? '總計' : ''}
          </Col>
        ))}
        <Col xs={2}>{totalSpend.toFixed(2)}</Col>
        <Col xs={2}>- -</Col>
        <Col xs={2}>- -</Col>
        <Col xs={2}>{totalProfit.toFixed(2)}</Col>
        {/* <Col xs={2}>- -</Col> */}
      </Row>
      {/* 可捲動區 */}
      <div style={{ height: '68vh', overflowY: 'auto' }}>
        {rows.map((r, i) => {
          const targetCA = ca[r.account_id] || ca[r.account_name.toLowerCase()]
          const profit = targetCA ? (1 + targetCA.AC * 0.01) * r.spend : r.spend
          return (
            <Row key={i} className="border-bottom flex-nowrap">
              {fields.map((f) => (
                <Col
                  xs={2}
                  className="text-nowrap App-oneLineEllipsis"
                  title={r[f.key]}
                  key={f.key}
                >
                  {r[f.key]}
                </Col>
              ))}
              <Col xs={2}>{(r.spend || 0).toFixed(2)}</Col>
              <Col
                xs={2}
                className="text-nowrap App-oneLineEllipsis"
                title={targetCA ? targetCA['客戶名稱'] : 'unknown'}
              >
                {targetCA ? targetCA['客戶名稱'] : 'unknown'}
              </Col>
              <Col xs={2}>
                {targetCA && targetCA.AC !== undefined
                  ? `${targetCA.AC}%`
                  : 'unknown'}
              </Col>
              <Col xs={2}>{profit.toFixed(2)}</Col>
              {/* <Col xs={2}>{r.provider}</Col> */}
            </Row>
          )
        })}
      </div>
      <Warn setting={{ show: false, handleClose: () => {} }} />
    </Container>
  )
}

Warn.propTypes = { setting: PropTypes.shape().isRequired }
